module.exports = __webpack_public_path__ + "static/media/league-nav-leaderboard-disabled.555dfb76.svg";